import { FC, ReactElement, useState } from 'react';
import { Button, Card } from '@shared/UI';
import classNames from 'classnames';
import './Tabs.scss';
import { useModal } from '@features/Modal';
import { BulkBuySellAdjustmentModal } from '@pages/Preferences/components/BulkRebalancingModal/BulkBuyAndSellModal';

interface ITabsContent {
    [key: string]: ReactElement;
}

interface ITabsProps {
    tabsContent: ITabsContent;
    initialTab?: string;
}

export const Tabs: FC<ITabsProps> = ({ tabsContent, initialTab }) => {
    const [selectedTab, setSelectedTab] = useState<keyof ITabsContent>(
        initialTab ? initialTab : Object.keys(tabsContent)[0],
    );

    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');

    const { open: openBulkBuySellAdjustmentModal } = useModal(BulkBuySellAdjustmentModal);

    const onBulkBuySellAdjustmentClick = () => {
        openBulkBuySellAdjustmentModal({});
    };

    return (
        <Card className={initialTab === 'Client Details' ? 'no-border-tabs-container' : 'tabs-container'}>
            <div style={{ display: 'flex', paddingLeft: '20px' }}>
                <ul className={'tabs'}>
                    {Object.keys(tabsContent).map((tabName) => (
                        <li
                            key={tabName}
                            className={classNames('tabs__item', { 'tabs__item--active': tabName === selectedTab })}
                            onClick={() => setSelectedTab(tabName)}
                        >
                            {tabName}
                        </li>
                    ))}
                </ul>
                {initialTab === 'Client Details' && userObject.userRole === 4 && (
                    <Button
                        onClick={onBulkBuySellAdjustmentClick}
                        color='primary'
                        className='bulk-rebalancing-button'
                    >
                        Rebalance
                    </Button>
                )}
            </div>
            {tabsContent[selectedTab]}
        </Card>
    );
};
